// src/services/providers/MockPaymentProvider.js
import { BasePaymentProvider } from './BasePaymentProvider.js';

function MockPaymentProvider(config) {
    BasePaymentProvider.call(this, config);
    this.name = 'mock_payments';
    this.testScenario = config.testScenario || 'SUCCESS';
}

MockPaymentProvider.prototype = Object.create(BasePaymentProvider.prototype);
MockPaymentProvider.prototype.constructor = MockPaymentProvider;

MockPaymentProvider.prototype.initialize = function() {
    return new Promise(function(resolve) {
        console.log('[MockPayment] Initialized in test mode');
        this.initialized = true;
        resolve();
    }.bind(this));
};

MockPaymentProvider.prototype.initPayment = function(orderData, userData) {
    var self = this;

    return new Promise(function(resolve, reject) {
        var scenarios = {
            SUCCESS: {
                success: true,
                transactionId: 'mock_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                cardHolderMessage: 'Платеж успешно завершен (тест)',
                provider: self.name,
                testMode: true,
                paymentData: {
                    TransactionId: 'mock_' + Date.now(),
                    Amount: orderData.amount || 0,
                    Currency: 'RUB',
                    DateTime: new Date().toISOString(),
                    CardFirstSix: '555555',
                    CardLastFour: '4444',
                    CardType: 'MasterCard',
                    TestMode: true
                }
            },

            FAILED: {
                success: false,
                error: 'Недостаточно средств (тест)',
                code: 'InsufficientFunds',
                provider: self.name,
                testMode: true
            },

            THREEDS: {
                success: true,
                requires3DSecure: true,
                transactionId: 'mock_3ds_' + Date.now(),
                acsUrl: 'https://test.cloudpayments.ru/acs',
                paReq: 'mock_pa_req_token',
                provider: self.name,
                testMode: true,
                paymentData: {
                    TransactionId: 'mock_3ds_' + Date.now(),
                    Requires3DSecure: true
                }
            }
        };

        var scenario = scenarios[self.testScenario] || scenarios.SUCCESS;

        setTimeout(function() {
            if (scenario.success === false) {
                var error = new Error(scenario.error);
                error.code = scenario.code;
                reject(error);
            } else {
                resolve(scenario);
            }
        }, 1000 + Math.random() * 2000);
    });
};

MockPaymentProvider.prototype.executePayment = function(paymentData) {
    var self = this;

    return new Promise(function(resolve, reject) {
        setTimeout(function() {
            if (self.testScenario === 'FAILED') {
                var error = new Error('Недостаточно средств (тест)');
                error.code = 'InsufficientFunds';
                reject(error);
                return;
            }

            var transactionId = 'mock_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

            resolve({
                success: true,
                transactionId: transactionId,
                cardHolderMessage: 'Платеж успешно завершен (тест)',
                provider: self.name,
                testMode: true,
                amount: paymentData.amount,
                orderId: paymentData.orderId,
                paymentData: {
                    TransactionId: transactionId,
                    Amount: paymentData.amount || 0,
                    Currency: 'RUB',
                    DateTime: new Date().toISOString(),
                    CardFirstSix: '555555',
                    CardLastFour: '4444',
                    CardType: 'MasterCard',
                    TestMode: true
                }
            });
        }, 1000 + Math.random() * 1000);
    });
};

MockPaymentProvider.prototype.confirmPayment = function(paymentData) {
    return Promise.resolve({
        success: true,
        paymentId: paymentData.transactionId || (paymentData.paymentData && paymentData.paymentData.TransactionId),
        status: 'confirmed',
        testMode: true,
        confirmedAt: new Date().toISOString()
    });
};

MockPaymentProvider.prototype.validateConfig = function() {
    return [];
};

export { MockPaymentProvider };